<edu-card>
  <h4 edu-card-title>Recommended Action Plan</h4>
  @if (studentName) {
    <h4 edu-card-subtitle>{{username}} - {{studentName}}</h4>
  }

  <div class="plan-container">
    @if (sortedIssues.length === 0) {
      <div class="no-issues">
        <p>No issues to display</p>
      </div>
    }

    <ul class="plan-timeline">
      @for (issue of sortedIssues; track issue) {
        <li class="plan-item" [class.completed]="isIssueCompleted(issue.id)">
          <div class="timeline-connector">
            <div class="timeline-dot" [style.backgroundColor]="getPriorityColor(issue.priority)"></div>
          </div>
          <div class="issue-content">
            <div class="issue-header">
              <div class="issue-title-row">
                <span class="issue-title">{{ issue.title }}</span>
                <!-- <span class="issue-category">{{ issue.category }}</span> -->
              </div>
            </div>
            @if (issue.todoItems && issue.todoItems.length > 0) {
              <div class="issue-progress-container">
                <h5 class="todo-title">Action Items</h5>
                <ul class="todo-list">
                  @for (todoItem of issue.todoItems; track todoItem; let i = $index) {
                    <li class="todo-item"
                      [class.completed]="todoItem.completed">
                      <div class="todo-main-item light-form">
                        <mat-checkbox color="primary" [disabled]="this.readonly" [id]="'todo-' + issue.id + '-' + i"
                          [checked]="todoItem.completed" (change)="toggleTodoCompletion(issue.id, i)"
                          [labelPosition]="'after'">
                          {{ todoItem.title }}
                        </mat-checkbox>
                      </div>
                      <!-- Sub-items section -->
                      @if (todoItem.subItems && todoItem.subItems.length > 0) {
                        <div class="todo-subitems-container">
                          <ul class="sub-items-list light-form">
                            @for (subItem of todoItem.subItems; track subItem; let j = $index) {
                              <li class="sub-item"
                                [class.completed]="subItem.completed">
                                <mat-checkbox [disabled]="this.readonly" color="primary"
                                  [id]="'sub-' + issue.id + '-' + i + '-' + j" [checked]="subItem.completed"
                                  (change)="toggleSubItemCompletion(issue.id, i, j)" [labelPosition]="'after'">
                                  {{ subItem.title }}
                                </mat-checkbox>
                              </li>
                            }
                          </ul>
                        </div>
                      }
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
        </li>
      }
    </ul>
  </div>
</edu-card>